export const roundStepsKeys = {
  roundStep1: '1dtp_ui.round_step_1',
  roundStep2: '1dtp_ui.round_step_2',
  roundStep3: '1dtp_ui.round_step_3',
  roundStep4: '1dtp_ui.round_step_4',
  roundStep5: '1dtp_ui.round_step_5',
  roundStep6: '1dtp_ui.round_step_6',
};
